/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiNotification } from '@Model';
import type { HttpActions, ListInfo, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of NotificationsController.
 */
export class NotificationsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /notifications:query
     */
    public query(pageNo: number, pageSize: number, onlyUnread: boolean): Promise<Result<ListInfo<ApiNotification>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        query.set('onlyUnread', `${onlyUnread}`);

        return this.http.get<Result<ListInfo<ApiNotification>>>('/notifications:query', query);
    }

    /**
     * Calls PATCH /notifications/{id}:acknowledge
     */
    public acknowledge(id: string): Promise<Result<boolean>> {
        return this.http.patch<Result<boolean>, undefined>(`/notifications/${id}:acknowledge`, undefined);
    }

    /**
     * Calls PATCH /notifications:acknowledge
     */
    public acknowledgeAll(): Promise<Result<number>> {
        return this.http.patch<Result<number>, undefined>('/notifications:acknowledge', undefined);
    }
}
